import { colors } from '@mui/material';
export default {
    styleOverrides: {
        colorPrimary: {
            background: `linear-gradient(45deg, #093170 20%, ${colors.blue[900]} 80%)`,
        },
    },
};
